import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=b3a5d96a&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a5d96a",
  null
  
)

export default component.exports